import { StatusPill } from "./StatusPill";

export default StatusPill;
